'use client';

import { useContext } from 'react';

import { ToastProviderContext } from '../context/toast-provider.context';

/**
 * Provides access to `ToastProvider` context to enqueue `Toast`s
 *
 * @example
 * const Component = () => {
 *   const { enqueueToast } = useToast();
 *
 *   return (
 *     <button type="button" onClick={() => enqueueToast(<Toast tone="critical">Hello</Toast>)}>
 *       Click
 *     </button>
 *   )
 * }
 */
export const useToast = () => useContext(ToastProviderContext);
